import { Modal } from 'bootstrap';
import { GiftCard } from 'shared/classes/GiftCard';
import { format_value } from 'shared/common/junkdrawer';
import { GIFT_CARD_STATUSES, PRODUCT_TYPES } from 'static/common/constants';

export function GiftCardViewModel(data) {


    var self = this;
    self.type = "GiftCardViewModel";

    self.rootvm = data.rootvm;

    // Constants
    self.GIFT_CARD_STATUSES = GIFT_CARD_STATUSES;
    self.PRODUCT_TYPES = PRODUCT_TYPES;

    self.error = ko.observable();

    self.search_name = ko.observable();
    self.start_date = ko.observable();
    self.end_date =ko.observable();

    self.filter_gift_card_status = ko.observable();
    self.filter_product_type = ko.observable();

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(40);

    self.gift_card_report = ko.observableArray([]);
    self.raw_gift_card_report = ko.observableArray([]);

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){
          self.lookup_gift_cards().then(function(){
                console.log('done looking up gift cards');
                self.initialized(true);
          })};
    }

    self.show_hidden = ko.observable(false);

    self.gift_cards = ko.observableArray([]);

    self.new_code = ko.observable();
    self.new_discount_amount = ko.observable();
    self.new_minimum_amount = ko.observable();
    self.new_expiration_date = ko.observable();
    self.new_can_use_pass_the_hat = ko.observable();
    self.new_can_use_pro_artist = ko.observable();
    self.new_currency = ko.observable();

    self.dc_info_modal = undefined;
    self.selected_gc_info = ko.observable(new GiftCard({}));

    self.show_more_gift_code_modal = ko.observable(false);

    self.editing_extra_comment = ko.observable(undefined);
    self.new_extra_comment = ko.observable(undefined);
    self.cancel_extra_comment = function(){
        self.editing_extra_comment(undefined);
    }

    self.save_extra_comment = function(row, element){
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/gift-report/extra-comment',
            type: 'POST',
            data:ko.toJSON({
                year: self.editing_extra_comment(),
                extra_comment: self.new_extra_comment()
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   row.extra_comment = self.new_extra_comment();

                    $(element)[0].currentTarget.parentElement.previousElementSibling.childNodes[1].innerText = self.new_extra_comment();
                   self.new_extra_comment(undefined);
                   self.editing_extra_comment(undefined);

                   notyf.success("Saved!");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    };

    self.gift_card_report_total = ko.computed(function(){

        const total_row = { total: 0, enabled: 0, redeemed: 0, expired: 0 }
        ko.utils.arrayForEach(self.raw_gift_card_report(), function(row){
            total_row['total'] += row.total
            total_row['enabled'] += row.enabled
            total_row['redeemed'] += row.redeemed
            total_row['expired'] += row.expired

        });

        total_row['total'] = format_value(total_row['total'], 'euro', 0);
        total_row['enabled'] = format_value(total_row['enabled'], 'euro', 0);
        total_row['redeemed'] = format_value(total_row['redeemed'], 'euro', 0);
        total_row['expired'] = format_value(total_row['expired'], 'euro', 0);
        return total_row

    });

    self.lookup_invoices_for_gc= function(gc){
        self.selected_gc_info(gc);
        self.selected_gc_info().lookup_invoices().then(() => {
            const gcInfoModal = document.getElementById('gcInfoModal');
            Modal.getOrCreateInstance(gcInfoModal).show();
        });
    };

    self.lookup_gift_cards = function(){
        self.rootvm.is_busy(true);

        if(self.end_date() == ''){
            self.end_date(undefined)
        }
        if(self.start_date() == ''){
            self.start_date(undefined)
        }
        if(self.limit() == -1 || self.limit() == ""){
            self.limit(undefined);
        }


        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/gift-cards',
            type: 'GET',
            data:{
                search_name: self.search_name(),
                start_date: self.start_date(),
                end_date: self.end_date(),
                gift_card_status: self.filter_gift_card_status(),
                product_type: self.filter_product_type(),
                offset: self.offset(),
                limit:  self.limit()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.gift_cards(ko.utils.arrayMap( data.gift_cards || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new GiftCard(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);

                self.raw_gift_card_report(data.gift_card_report);
                self.gift_card_report(ko.utils.arrayMap(data.gift_card_report,
                    function(row){
                    row['total'] = format_value(row['total'], 'euro', 0);
                    row['enabled'] = format_value(row['enabled'], 'euro', 0);
                    row['redeemed'] = format_value(row['redeemed'], 'euro', 0);
                    row['expired'] = format_value(row['expired'], 'euro', 0);
                    return row
                }));

                console.log(self.gift_card_report());


            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });

    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));
        if(self.offset() < 0){
            self.offset(0);
        }

        self.lookup_gift_cards().then(function(){
            pager.navigate("#tools/giftcard-list"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_gift_cards().then(function(){
            pager.navigate("#tools/giftcard-list"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };


};
